import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { storage } from '../../../helpers/Firebase';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    HL_SUPPLIER,
    HL_CATEGORY,
    HL_LIST,
    HL_ADD,
    HL_EDIT,
    HL_UPLOAD_SET
} from "../../actions";

import {
    HLSupplierSuccess,
    HLSupplierError,
    HLCategorySuccess,
    HLCategoryError,
    HLListSuccess,
    HLListError,
    HLAddSuccess,
    HLAddError,
    HLEditSuccess,
    HLEditError,
    HLUploadSetSuccess,
    HLUploadSetError
} from '../../actions';


export function* watchHLSupplier() {
    yield takeEvery(HL_SUPPLIER, onHLSupplier);
}

export function* watchHLCategory() {
    yield takeEvery(HL_CATEGORY, onHLCategory);
}

export function* watchHLList() {
    yield takeEvery(HL_LIST, onHLList);
}

export function* watchHLAdd() {
    yield takeEvery(HL_ADD, onHLAdd);
}

export function* watchHLEdit() {
    yield takeEvery(HL_EDIT, onHLEdit);
}

export function* watchHLUploadSet() {
    yield takeEvery(HL_UPLOAD_SET, onHLUploadSet);
}
function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onHLSupplierAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthLicense/supplier', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHLCategoryAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthLicense/category', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHLListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthLicense/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
}

const onHLAddAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthLicense/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHLEditAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthLicense/edit', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHLUploadSetAsync = async (file) => {
    var storageRef = storage.ref();
    let filename = file.name;
    return await new Promise((success, reject) => {
        var uploadTask = storageRef.child(storagePath + '/healthLicense/' + filename).put(file);
        uploadTask.on('state_changed',
            function (snapshot) {
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
            },
            function (error) {
                reject({ name: filename, original: file.name, message: error.code, url: '', type: file.type, size: file.size, path: 'healtHLegistration/' })
            },
            function () {
                uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                    success({ message: 'success', name: filename, original: file.name, url: downloadURL });
                });
            });
    });
};

function* onHLSupplier(data) {
    try {
        const response = yield call(onHLSupplierAsync, data.payload);
        yield put(HLSupplierSuccess(response.data));
    } catch (error) {
        yield put(HLSupplierError(error));
    }
}

function* onHLCategory(data) {
    try {
        const response = yield call(onHLCategoryAsync, data.payload);
        yield put(HLCategorySuccess(response.data));
    } catch (error) {
        yield put(HLCategoryError(error));
    }
}

function* onHLList(data) {
    try {
        const response = yield call(onHLListAsync, data.payload);
        yield put(HLListSuccess(response.data));
    } catch (error) {
        yield put(HLListError(error));
    }
}

function* onHLAdd(data) {
    try {
        const response = yield call(onHLAddAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(HLAddSuccess(response.data));
    } catch (error) {
        yield put(HLAddError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onHLEdit(data) {
    try {
        const response = yield call(onHLEditAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(HLEditSuccess(response.data));
    } catch (error) {
        yield put(HLEditError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onHLUploadSet({ payload }) {
    const { file } = payload;
    try {
        const response = yield call(onHLUploadSetAsync, file);
        console.log("response" + JSON.stringify(response));
        if (response.message === 'success') {

            yield put(HLUploadSetSuccess(response));

        }
        else {
            yield put(HLUploadSetError(response));
        }
    } catch (error) {
        yield put(HLUploadSetError({ name: '', original: file.name, message: error, url: '', path: '' }))
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchHLSupplier),
        fork(watchHLCategory),
        fork(watchHLList),
        fork(watchHLAdd),
        fork(watchHLEdit),
        fork(watchHLUploadSet)
    ]);
}